class Service {

    constructor(rootStore) {
        this.rootStore = rootStore;
    }

    get proSignupFunnelModalStore() {
        const {proSignupFunnelModalStore} = this.rootStore.stores;
        return proSignupFunnelModalStore;
    }

    get value() {
        return this.proSignupFunnelModalStore.service || {};
    }
}

export default Service;